<template>
  <div
    class="ba-flex ba-flex-col ba-w-full ba-min-h-full ba-px-8 ba-py-5 ba-bg-white ba-rounded"
  >
    <header
      class="ba-flex ba-justify-between ba-items-center ba-mb-4 ba-pb-4 ba-border-b"
    >
      <!-- TITLE -->
      <div class="ba-font-wellingtons-medium">
        <h3 class="">{{ documentItem.sender }}</h3>
        <p class="ba-mb-2 ba-font-wellingtons-demibold">
          {{ documentItem.theme }}
        </p>
      </div>
      <!-- ===================== -->

      <!-- ACTIONS -->
      <div class="ba-flex ba-flex-shrink-0">
        <button
          type="button"
          class="ba-flex ba-justify-center ba-items-center ba-w-8 ba-h-8 ba-mr-2 ba-bg-accent ba-rounded-full ba-opacity-90 hover:ba-opacity-100"
          @click="$emit('showModal')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path
              d="M10.6,1.9L13,4c0.3,0.2,0.4,0.5,0.4,0.9v1.6h-1V5.6H9.5C9.1,5.6,8.8,5.3,8.8,5V2.3H3.9c-0.2,0-0.4,0.2-0.5,0.4v10.6c0,0.2,0.2,0.4,0.5,0.4h8.2c0.2,0,0.4-0.2,0.5-0.4v-0.8h0.9v0.8c0,0.7-0.7,1.3-1.4,1.2H3.9c-0.7,0-1.3-0.5-1.4-1.2V2.7c0-0.7,0.7-1.3,1.4-1.2h5.7C10,1.5,10.3,1.6,10.6,1.9z M12.4,4.8c0-0.1-0.1-0.1-0.1-0.2L9.9,2.4c0,0-0.1-0.1-0.2-0.1v2.4L12.4,4.8L12.4,4.8z"
              fill="#fff"
            />
            <path
              d="M11.9,8.2l2.3,2.3 M11.9,10.5l2.3-2.3"
              fill="#fff"
              stroke="#fff"
              stroke-linecap="round"
              stroke-width="1"
            />
          </svg>
        </button>
        <button
          type="button"
          class="ba-flex ba-justify-center ba-items-center ba-w-8 ba-h-8 ba-bg-accent ba-rounded-full ba-opacity-90 hover:ba-opacity-100"
          @click="$emit('delete')"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
          >
            <path
              d="M12.8,3.1h-2.4L9.7,2C9.6,1.8,9.5,1.7,9.4,1.7C9.2,1.6,9.1,1.5,8.9,1.5H7.1c-0.2,0-0.3,0.1-0.5,0.2C6.5,1.7,6.4,1.8,6.2,2L5.5,3.1H3.2C3.1,3.1,3,3.1,3,3.2C3,3.2,3,3.3,3,3.4v0.4C3,3.9,3,3.9,3,3.9c0,0,0.1,0,0.2,0h0.4l0.7,9.4c0,0.3,0.2,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.7,0.3h5.2c0.2,0,0.6-0.1,0.7-0.3c0.2-0.2,0.3-0.5,0.3-0.8l0.7-9.4h0.4c0.1,0,0.1,0,0.2-0.1c0,0,0.1-0.1,0.1-0.2V3.3c0-0.1,0-0.1-0.1-0.2C12.9,3.1,12.9,3.1,12.8,3.1L12.8,3.1z M6.8,2.5c0-0.1,0.1-0.1,0.2-0.1C7,2.3,7,2.3,7.1,2.3h1.8c0.1,0,0.1,0,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1l0.4,0.6H6.4L6.8,2.5z M10.9,13.3c0,0.1-0.1,0.2-0.1,0.2c-0.1,0.2-0.2,0.2-0.2,0.2H5.4c-0.1,0-0.2,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.2L4.3,3.9h7.4L10.9,13.3z"
              fill="#b7bacc"
            />
          </svg>
        </button>
      </div>
      <!-- ===================== -->
    </header>

    <div class="ba-flex ba-flex-col ba-flex-1 ba-mb-4">
      <!-- DATE =================================================== -->
      <div class="ba-mb-4">
        <p class="ba-text-xs ba-font-inter-regular ba-text-text-dark-grey">
          {{ formatDateTime(documentItem.date) }}
        </p>
      </div>
      <!-- LETTER BODY =================================================== -->
      <iframe
        ref="frame"
        sandbox="allow-same-origin"
        scrolling="yes"
        marginHeight="0"
        frameBorder="0"
        class="ba-flex-1"
      >
      </iframe>
    </div>

    <!-- DOCUMENTS LIST =================================================== -->
    <div class="ba-flex ba-flex-wrap ba-pt-6">
      <vis-filestorage-link
        v-for="link in docList"
        :key="link"
        :server-api="serverApi"
        :file-handler-api="fileHandlerApiUrl"
        :link="link"
        class="ba-mr-2 ba-mb-2 ba-font-inter-regular"
        :showPreview="false"
      />
    </div>
    <!-- =================================================== -->
  </div>
</template>

<script>
import VisFilestorageLink from "@/views/vis-filestorage-link";
import globalState from "@/shared/global-state";
import { formatDateTime } from "@/shared/date";
import fileStorageHandlers from "@/shared/file-storage-handlers";

export default {
  name: "vis-docmail-body-design",
  components: {
    VisFilestorageLink,
  },
  props: {
    documentItem: { type: Object },
  },
  data() {
    return {
      docList: [],
      serverApi: globalState.launchConfig.fileStorage.serverApiUrl,
      fileHandlerApiUrl: globalState.launchConfig.fileStorage.fileHandlerApiUrl,
    };
  },
  methods: {
    onOpenFile(e) {
      const data = fileStorageHandlers.actionHandlers.filter(
        (x) => x.extension === e.file.extension
      );
      if (data.length > 0) {
        e.file.done = function (e) {};
        data[0].action(e.file);
      }
    },
    formatDateTime(date) {
      return formatDateTime(date);
    },
    setContentAndFiles() {
      if (this.documentItem) {
        let element = this.$refs.frame;
        var doc = element.contentWindow
          ? element.contentWindow.document
          : element.contentDocument;
        doc.open();
        doc.write(this.documentItem.text);
        doc.close();
        this.docList = (this.documentItem.files || "")
          .split(",")
          .filter(function (s) {
            return !!s;
          });
      }
    },
  },
  watch: {
    documentItem(val) {
      this.setContentAndFiles();
    },
  },
  created() {
    this.$nextTick(this.setContentAndFiles);
  },
};
</script>
